export const EXTERNAL_LINK = 'external_link';
export const PAGE_LINK = 'link_to_page';
export const SUBMIT_FORM = 'submit_form';
export const CLOSE_POPUP = 'close_popup';
export const NONE = 'no_button';
